import type { IconData } from "./iconData.types";
import placeholder from "./iconDataFiles/placeholder";

type IconModuleType = {
  default: IconData;
};

const iconModules = import.meta.glob<IconModuleType>([
  "./iconDataFiles/*.tsx",
  "!./iconDataFiles/placeholder.tsx",
]);
const iconDataPromises = new Map<string, Promise<IconData>>();

export const placeholderIconData: IconData = placeholder;

export default function loadIconData(name: string): Promise<IconData> {
  const iconName = name || "placeholder";
  const existingPromise = iconDataPromises.get(iconName);

  if (existingPromise) {
    return existingPromise;
  }

  const loader = iconModules[`./iconDataFiles/${iconName}.tsx`];

  if (!loader) {
    return Promise.resolve(placeholderIconData);
  }

  const promise = loader()
    .then((module) => module.default)
    .catch(() => placeholderIconData);

  iconDataPromises.set(iconName, promise);
  return promise;
}
